import { BrowserRouter } from "react-router-dom";
import { Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Menu from "./pages/Menu";
import Community from "./pages/Community";
import SignUp from "./pages/SignUp";
import Login from "./pages/Login";
import Blog from "./pages/Blog";
import Blog2 from "./pages/Blog2"
import Dashboard from "./pages/Dashboard";
import Inventory from './pages/Inventory';
import Invoice1 from "./pages/Invoice1";
import Invoice2 from "./pages/Invoice2";
import Invoice3 from "./pages/Invoice3";
import './index';


function App() {
  return (
    <>
    <BrowserRouter>
    <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/menu" element={<Menu />} />
          <Route path="/community" element={<Community />} />
          <Route path="/SignUp" element={<SignUp />} />
          <Route path="/Login" element={<Login />} />
          <Route path="/Blog" element={<Blog />} />
          <Route path="/Blog2" element={<Blog2 />} />
          <Route path="/Inventory" element={<Inventory />} />
          <Route path="/Dashboard" element={<Dashboard />} />
          <Route path="/Invoice1" element={<Invoice1 />} />
          <Route path="/Invoice2" element={<Invoice2 />} />
          <Route path="/Invoice3" element={<Invoice3 />} />
          </Routes>
        
    </BrowserRouter>
    </>
  );
}

export default App;
